import React from "react";
import {
  ReleaseNotesPageWrapper,
  ReleaseNotesContainer,
  ReleaseNotesTitle,
  QuarterHeader,
  QuarterSection,
  QuarterContent,
} from "./ReleaseNotes.styles";

const releaseNotes = [
  {
    quarter: "Q2 2025",
    content:
      "Providers can now easily access and request our security certifications and compliance documentation through our newly launched <a target='_blank' href='https://trust.billiontoone.com/'>Trust Center</a>, providing enhanced transparency into our security practices. We've improved the patient registration and authentication process, delivering a more intuitive signup and login experience.<br><br>Launched an expanded offering for providers utilizing the Unity Fetal Risk™ Screen. This expanded offering screens for the five recessive, severe, and actionable conditions that American College of Obstetricians and Gynecologists (ACOG) guidelines recommend offering screening for in every pregnancy plus nine additional actionable conditions commonly found in Ashkenazi Jewish and pan-ethnic populations.",
  },
  {
    quarter: "Q1 2025",
    content:
      "We celebrated serving over one million tests, a significant milestone for the Provider Portal. Support for multiple tests for a single patient was implemented, leading to a better patient experience. We focused on performance enhancements, resulting in a speedier and more dynamic user experience. These improvements have significantly allowed more efficient access to critical information.",
  },
  {
    quarter: "Q4 2024",
    content:
      "We launched the FedEx pickup functionality, giving users the ability to self schedule pickups at their convenience and for more direct service. We are now offering Babypeek at $9.99.",
  },
  {
    quarter: "Q3 2024",
    content:
      "Security and performance enhancements were made to ensure that we have appropriate HIPAA security standards. We implemented advanced browser security measures.",
  },
];

const ReleaseNotes = (): React.ReactElement => (
  <ReleaseNotesPageWrapper>
    <ReleaseNotesContainer>
      <ReleaseNotesTitle>Provider Portal Release Notes</ReleaseNotesTitle>

      {releaseNotes.map((quarterData, index) => (
        <QuarterSection key={quarterData.quarter}>
          <QuarterHeader>{quarterData.quarter}</QuarterHeader>
          <QuarterContent
            dangerouslySetInnerHTML={{ __html: quarterData.content }}
          />
        </QuarterSection>
      ))}
    </ReleaseNotesContainer>
  </ReleaseNotesPageWrapper>
);

export default ReleaseNotes;
